export enum ContractorResourceTypeEnum {
  Hanger = 'Hanger',
  Finisher = 'Finisher',
  Sprayer = 'Sprayer',
  Bumper = 'Bumper',
  Paint = 'Paint',
  Trim = 'Trim',
}
